import { type FC, useContext, useMemo } from "react";
import { DragDropEditorContext, type DragDropSettingsProps } from "../../../Forms/DragDrop/DragDropTypes";
import { hasColumnsValue, ReorderableTableSettings } from "../../../Forms/DragDrop/ReorderableTableSettings";
import { ReceiptAccountContext } from "../../Receipt";

export const ReceiptTotalTableSettings: FC<DragDropSettingsProps> = ({
    id,
    value,
}) => {
    const { manager } = useContext(DragDropEditorContext);

    const account = useContext(ReceiptAccountContext);

    const columnDefinitions = useMemo((): Record<string, string> => {
        if(account) {
            return {
                total       : "Total",
                invoiceCount: "Invoices",
                outstanding : "Outstanding",
                change      : "Change",
                rounding    : "Rounding",
            };
        }

        return {
            rounding: "Rounding",
            savings : "Savings",
            discount: "Discount",
            sale    : "Total",
            change  : "Change",
        };
    }, [ account ]);

    const columns = hasColumnsValue(value) ? value.columns : [];

    return (
        <ReorderableTableSettings
            renameable
            columns={columnDefinitions}
            value={columns}
            onChange={columns => {
                manager.updateComponent(id, {
                    ...(hasColumnsValue(value) ? value : {}),
                    columns,
                });
            }}
        />
    );
};
